import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities, deleteEntity } from 'redux-modules/entity'

import api from 'api'

const FETCH_REQUEST = 'realhub/artwork/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/artwork/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/artwork/FETCH_FAILURE'
const CREATE_REQUEST = 'realhub/artwork/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/artwork/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/artwork/CREATE_FAILURE'
const UPDATE_REQUEST = 'realhub/artwork/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/artwork/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/artwork/UPDATE_FAILURE'
const DELETE_REQUEST = 'realhub/artwork/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/artwork/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/artwork/DELETE_FAILURE'

const SHARE_REQUEST = 'realhub/artwork/SHARE_REQUEST'
const SHARE_SUCCESS = 'realhub/artwork/SHARE_SUCCESS'
const SHARE_FAILURE = 'realhub/artwork/SHARE_FAILURE'

const SELECT_ARTWORK = 'realhub/artwork/SELECT_ARTWORK'

// Initial State
const initialState = {
  result: [],
  selectedId: null,
  loaded: false,
  loading: false,
  creating: false,
  updating: false,
  deleting: false,
  sharing: false,
  errors: [],
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    result: payload.result,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(payload = {}){
  return {
    type: CREATE_SUCCESS,
    result: payload.result,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(payload = {}){
  return {
    type: UPDATE_SUCCESS,
    result: payload.result,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(payload = {}){
  return {
    type: DELETE_SUCCESS,
    result: payload.result,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

export function shareRequest(){
  return {
    type: SHARE_REQUEST,
  }
}

export function shareSuccess(){
  return {
    type: SHARE_SUCCESS,
  }
}

export function shareFailure(errors = []){
  return {
    type: SHARE_FAILURE,
    errors,
  }
}

export function selectArtwork(artwork){
  return (dispatch, getState) => {
    const state = getState()
    const artworks = state.entities.artworks

    const selectedArtwork = artworks[artwork.id]

    dispatch({
      type: SELECT_ARTWORK,
      selectedId: artwork.id,
      selected: selectedArtwork,
    })
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function addArtwork(artwork){
  const normalizedJson = normalize(artwork, Schemas.ARTWORK)

  return (dispatch) => {
    dispatch(updateEntities(normalizedJson))
  }
}

export function hydrateArtwork(artworkJson){
  return (dispatch) => {
    dispatch(fetchRequest())

    if (artworkJson.id){
      const normalizedJson = normalize(artworkJson, Schemas.ARTWORK)
      dispatch(updateEntities(normalizedJson))
      dispatch(fetchSuccess(normalizedJson))
    } else {
      dispatch(fetchFailure(['Could not hydrate undefined artwork.']))
    }
  }
}

export function loadArtworks(options){
  return (dispatch) => {
    // Set Loading
    dispatch(fetchRequest())

    const promise = api('/agency/artworks.json', options)
      .then(response => (
        response.json().then(json => ({ json, response }))
      ))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.ARTWORK_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(normalizedJson))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function createArtwork(orderItem, templatePage, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      v2: true,
      artwork: {
        campaign_id: orderItem.campaign_id,
      },
      artwork_page: {
        template_page_id: templatePage.id,
      },
    }),
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api(`/agency/order_items/${orderItem.id}/artworks.json`, options, config)
      .then(response => (
        response.json().then(json => ({ json, response }))
      ))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Add to result array
        const resultArray = getState().artworks.result ? getState().artworks.result.slice() : []
        resultArray.push(json.id)

        const normalizedJson = normalize(json, Schemas.ARTWORK)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess({ result: resultArray }))

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function createArtworkFromSaved(orderItem, savedArtwork, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      order_item_id: orderItem.id,
    }),
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api(`/agency/saved_artworks/${savedArtwork.id}/restore_as_artwork.json`, options, config)
      .then(response => (
        response.json().then(json => ({ json, response }))
      ))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Add to result array
        const resultArray = getState().artworks.result ? getState().artworks.result.slice() : []
        resultArray.push(json.id)

        const normalizedJson = normalize(json, Schemas.ARTWORK)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess({ result: resultArray }))

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function createArtworkFromSavedPage(orderItem, savedArtworkPage, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      order_item_id: orderItem.id,
    }),
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(createRequest())

    const url = `/agency/saved_artwork_pages/${savedArtworkPage.id}/restore_as_artwork.json`
    const promise = api(url, options, config)
      .then(response => (
        response.json().then(json => ({ json, response }))
      ))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Add to result array
        const resultArray = getState().artworks.result ? getState().artworks.result.slice() : []
        resultArray.push(json.id)

        const normalizedJson = normalize(json, Schemas.ARTWORK)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess({ result: resultArray }))

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function deleteArtwork(artwork, callback){
  const config = {
    method: 'DELETE',
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(deleteRequest())

    const promise = api(`/agency/order_items/${artwork.order_item_id}/artworks/${artwork.id}.json`, {}, config)
      .then(response => (
        response.json().then(json => ({ json, response }))
      ))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Remove from result array
        const resultArray = getState().artworks.result ? getState().artworks.result.slice() : []
        const index = resultArray.indexOf(artwork.id)
        if (index !== -1){
          resultArray.splice(index, 1)
        }

        const normalizedJson = normalize(json, Schemas.ARTWORK)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess(resultArray))

        if (callback){
          callback(json)
        }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))
      })

    return promise
  }
}

export function approveArtwork(artwork, options){
  const config = {
    method: 'PUT',
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const url = `/agency/order_items/${artwork.order_item_id}/artworks/${artwork.id}/approve.json`
    const promise = api(url, options, config)
      .then(response => (
        response.json().then(json => ({ json, response }))
      ))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.ARTWORK)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

export function unapproveArtwork(artwork, options){
  const config = {
    method: 'PUT',
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/agency/order_items/${artwork.order_item_id}/artworks/${artwork.id}/unapprove.json`, options, config)
      .then(response => (
        response.json().then(json => ({ json, response }))
      ))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.ARTWORK)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        result: action.result,
        errors: [],
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        loaded: false,
        errors: action.errors,
      })
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true,
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        result: action.result,
        errors: [],
      })
    case CREATE_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        errors: action.errors,
      })
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true,
      })
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        errors: [],
      })
    case UPDATE_FAILURE:
      return Object.assign({}, state, {
        updating: false,
        errors: action.errors,
      })
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        deleting: true,
      })
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        deleting: false,
        result: action.result,
        errors: [],
      })
    case DELETE_FAILURE:
      return Object.assign({}, state, {
        deleting: false,
        errors: action.errors,
      })
    case SHARE_REQUEST:
      return Object.assign({}, state, {
        sharing: true,
      })
    case SHARE_SUCCESS:
      return Object.assign({}, state, {
        sharing: false,
        errors: [],
      })
    case SHARE_FAILURE:
      return Object.assign({}, state, {
        sharing: false,
        errors: action.errors,
      })
    case SELECT_ARTWORK:
      return Object.assign({}, state, {
        selectedId: action.selectedId,
      })
    default:
      return state
  }
}
